import type { ConsentFieldType } from '@Types/GF/Fields';

import { useEffect, useState } from 'react';

import { ErrorIcon } from '@/views/Shared/Icons';

import CheckBox from '../../components/CheckBox';

type Props = {
	field: ConsentFieldType;
	setFormValues: React.Dispatch<any>;
	formValues: any;
	errorMessage: string;
};

export default function ConsentField({ field, setFormValues, formValues, errorMessage }: Props) {
	const { id, formId, type, label, description, cssClass, isRequired, checkboxLabel } = field;
	const htmlId = `field_${formId}_${id}`;

	const [isChecked, setIsChecked] = useState(false);

	const checkHandler = () => {
		setIsChecked(!isChecked);
	};

	const updateValues = (value: any) => {
		const _form = { ...formValues };
		_form.values[`input_${id}_1`] = value;
		setFormValues(_form);
	};

	useEffect(() => {
		if (isChecked) {
			updateValues(1);
		} else {
			updateValues(0);
		}
	}, [isChecked]);

	return (
		<div className={`mb-5 gfield gfield-${type} ${cssClass}`.trim()}>
			{errorMessage && (
				<p className={`mb-3 mt-1 inline-flex items-center gap-2 text-base text-minos-form-error-color`}>
					<ErrorIcon />
					{errorMessage}
				</p>
			)}
			{label && (
				<legend
					className={`${
						isRequired &&
						'after:ml-0.5 after:font-semibold after:text-minos-form-require-color after:content-["*"]'
					} ${description ? 'mb-1' : 'mb-2'}`}
				>
					{label}
				</legend>
			)}

			{description ? (
				<p className='minos-form-content-font-style mb-2 text-base tablet:minos-form-content-font-style'>
					{description}
				</p>
			) : null}
			<CheckBox
				name={`${htmlId}.1`}
				id={`${htmlId}_1`}
				value='1'
				aria-invalid='false'
				required={Boolean(isRequired)}
				checked={isChecked}
				onChange={checkHandler}
				htmlFor={htmlId}
				label={checkboxLabel}
				ariaLabel={checkboxLabel}
			/>
		</div>
	);
}
